import {IFinscanCategoriesListsDto} from "./finscan-categories-list.model";

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export const enum ListName{
    EUROPEAN_SANCTION = 'EUROPEAN_SANCTION',
    EUROPEAN_UNION_TERRORISTS = 'EUROPEAN_UNION_TERRORISTS',
    OFAC_SPECIALLY_DESIGNATED_NATIONALS = 'OFAC_SPECIALLY_DESIGNATED_NATIONALS',
    OFAC_CONSOLIDATED_LIST = 'OFAC_CONSOLIDATED_LIST',
    OFAC_NON_PROLIFERATION='OFAC_NON_PROLIFERATION',
    BELGIUM_FEDERAL_PUBLIC_SERVICE_FINANCIAL_SANCTIONS_LIST= 'BELGIUM_FEDERAL_PUBLIC_SERVICE_FINANCIAL_SANCTIONS_LIST',
    LISTE_UNIQUE_DE_GEL_DE_LA_DIRECTION_GÉNÉRALE_DU_TRÉSOR = 'LISTE_UNIQUE_DE_GEL_DE_LA_DIRECTION_GÉNÉRALE_DU_TRÉSOR',
    UNITED_NATIONS_SANCTIONS = 'UNITED_NATIONS_SANCTIONS'
}


export interface IFinscanSanctionListsDto {
    id?: string;
    isFullSource?: boolean;
    enabledList?:boolean;
    statusMessage?: string;
    masterId?: string;
    statusType?:string;
    listId?:string;
    listName?:string;
    categoriesList: IFinscanCategoriesListsDto[];
    finscanSanctionListName?:string;
}



export class FinscanSanctionListsDto implements IFinscanSanctionListsDto {
    constructor(
        public id?: string,
        public isFullSource?: boolean,
        public enabledList?:boolean,
        public statusMessage?: string,
        public masterId?: string,
        public statusType?:string,
        public listId?:string,
        public listName?:string,
        public categoriesList: IFinscanCategoriesListsDto[]=[],
        public finscanSanctionListName?:string

    ) {
        
        this.enabledList = false;

        if(listName!=null&&listName!=undefined) {
            this.finscanSanctionListName = FinscanSanctionListsDto.getlistName(listName);
        }
    }

    public static getlistName(listName): string {
        switch(listName) {
            case ListName.EUROPEAN_SANCTION:
                return 'European Sanction';
            case ListName.EUROPEAN_UNION_TERRORISTS:
                return 'European Union Terrorists';
            case ListName.OFAC_SPECIALLY_DESIGNATED_NATIONALS:
                return 'OFAC Specially Designated Nationals';
            case ListName.OFAC_CONSOLIDATED_LIST:
                return 'OFAC Consolidated List';
            case ListName.BELGIUM_FEDERAL_PUBLIC_SERVICE_FINANCIAL_SANCTIONS_LIST:
                return 'Belgium Federal Public Service Financial Sanctions List';
            case ListName.LISTE_UNIQUE_DE_GEL_DE_LA_DIRECTION_GÉNÉRALE_DU_TRÉSOR:
                return 'Liste Unique de Gels de la Direction générale du Trésor';
            case ListName.UNITED_NATIONS_SANCTIONS:
                return 'United Nations Sanctions';
        }
    }

}










